// Components
import { ImageFallback } from '@shared/ui';
import RoleBadge from '../RoleBadge';

// Utils
import { getColorBaseOnRole } from '@/utils';

// Constants
import { IMAGES } from '@shared/constants';
export interface UserCardProps {
  name: string;
  avatar?: string;
  title?: string;
}
export const UserCard = ({
  name,
  avatar = IMAGES.AVATAR_DEFAULT,
  title = ''
}: UserCardProps) => {
  const color = getColorBaseOnRole(title);
  return <>
      <div className="relative size-12 shrink-0">
        <ImageFallback src={avatar} alt={avatar} fill className="rounded-full object-cover" data-sentry-element="ImageFallback" data-sentry-source-file="index.tsx" />
      </div>
      <div className="flex-1">
        <p className="text-frost-900 font-semibold text-xs">{name}</p>
        {title && <RoleBadge label={title} color={color} className="cursor-auto" labelClassName="text-5xs" />}
      </div>
    </>;
};